// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3u_jQ","errorLogs":"EditorFooter_errorLogs__3Ym5o"};